<template>
    <a :href="`${publicPath}${file}`" :title="title" :target="target" >
      <img :src="`${publicPathImage}img/pdf.png`" class="img-responsive">
    </a>
</template>

<script>
export default {
  props: {
    title: String,
    file: String,
    showtitle: {
      type: Boolean,
      default: false
    },
    target: {
      type: String,
      default: "_blank"
    }
  },
  data () {
    return {
      publicPath: process.env.BASE_URL+"downloads/",
      publicPathImage: process.env.BASE_URL
    }
  }
}
</script>
